var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "func-modal",
        {
          ref: "modal",
          attrs: { title: _vm.modalTitle },
          on: { close: _vm.onClose },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function(props) {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      class: [{ disabled: _vm.processing }],
                      attrs: { disabled: _vm.processing },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.submit()
                        }
                      }
                    },
                    [
                      _vm.processing
                        ? _c("i", { staticClass: "fa fa-spin fa-spinner" })
                        : _vm._e(),
                      _vm._v("\n                Submit\n            ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-link",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return props.close()
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "body" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v(_vm._s(_vm.modalDescription))]),
              _vm._v(" "),
              _c("div", { staticClass: "radio" }, [
                _c("label", { staticClass: "margin-bottom-1x" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.type,
                        expression: "type"
                      }
                    ],
                    attrs: { type: "radio", value: "charge" },
                    domProps: { checked: _vm._q(_vm.type, "charge") },
                    on: {
                      change: function($event) {
                        _vm.type = "charge"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.updateLabel) + ": " + _vm._s(_vm.currentTime)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("label", { staticClass: "margin-bottom-1x" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.type,
                        expression: "type"
                      }
                    ],
                    attrs: { type: "radio", value: "without_charge" },
                    domProps: { checked: _vm._q(_vm.type, "without_charge") },
                    on: {
                      change: function($event) {
                        _vm.type = "without_charge"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("strong", [_vm._v(_vm._s(_vm.skipUpdateLabel))])
                ])
              ])
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("confirm-extend-reservation-modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.reservation,
            expression: "reservation"
          }
        ],
        ref: "confirmExtendReservationModal",
        attrs: { processing: _vm.checkout_processing },
        on: {
          "update-processing": _vm.updateProcessing,
          "update-reservation": _vm.updateReservation,
          close: _vm.onClose
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-756dc7e7", { render: render, staticRenderFns: staticRenderFns })
  }
}